class GallerySliders {
    constructor() {
        this.init();
    }

    getVariantIdFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('variant');
    }

    setActiveSlide(slider, variantId) {
        const slides = slider.Components.Elements.slides;
        slides.forEach((slide, index) => {
            const slideVariantId = slide.getAttribute('data-variant-id');
            if (slideVariantId === variantId) {
                slider.go(index); 
            }
        });
    }

    initMobilePdpGallerySlider() {
        const mobileSliderOptions = {
            arrows: false,
            pagination: false,
        };

        const mobileSlider = new Splide('#splide-slider', mobileSliderOptions);
        mobileSlider.mount();

        const variantId = this.getVariantIdFromUrl();
        if (variantId) {
            this.setActiveSlide(mobileSlider, variantId);
        }

        this.listenForUrlChanges(mobileSlider);
    }

    initDesktopPdpGallerySlider() {
        const desktopMainSliderOptions = {
            type: 'fade',
            heightRatio: 0.5,
            pagination: false,
            arrows: false,
            cover: true,
        };

        const thumbnailsSliderOptions = {
            type: 'slide',
            rewind: false,
            height: '100%',
            gap: '15px',
            isNavigation: true,
            pagination: false,
            direction: 'ttb',
            drag: true,
            focus: 1,
            perPage: 3,
            breakpoints: {
                768: { perPage: 3 },
            },
        };

        const desktopThumbnailSlider = new Splide("#thumbnail-slider", thumbnailsSliderOptions);
        desktopThumbnailSlider.mount();

        const desktopMainSlider = new Splide('#main-slider', desktopMainSliderOptions);
        desktopMainSlider.sync(desktopThumbnailSlider);
        desktopMainSlider.mount();

        const variantId = this.getVariantIdFromUrl();
        if (variantId) {
            this.setActiveSlide(desktopMainSlider, variantId);
        }

        this.listenForUrlChanges(desktopMainSlider);
    }

    listenForUrlChanges(slider) {
        window.addEventListener('popstate', () => {
            const variantId = this.getVariantIdFromUrl();
            if (variantId) {
                this.setActiveSlide(slider, variantId);
            }
        });

        window.addEventListener('hashchange', () => {
            const variantId = this.getVariantIdFromUrl();
            if (variantId) {
                this.setActiveSlide(slider, variantId);
            }
        });

        let lastUrl = window.location.href;
        setInterval(() => {
            if (window.location.href !== lastUrl) {
                lastUrl = window.location.href;
                const variantId = this.getVariantIdFromUrl();
                if (variantId) {
                    this.setActiveSlide(slider, variantId);
                }
            }
        }, 500);
    }

    init() {
        document.addEventListener('DOMContentLoaded', () => {
            this.initMobilePdpGallerySlider();
            this.initDesktopPdpGallerySlider();
        });
    }
}

new GallerySliders();
